import { SmartSuggestService } from "core-library/components/smart-suggest/smart-suggest.service";
import { SearchResponseModel } from "core-library/components/smart-suggest/suggest-response.model";
import { debounce } from "lodash";

export class SmartSuggestComponent {

    private _apiUrl: string = null;
    private _searchPageUrl: string = null;
    private _homePageId: string = null;
    private _context: JQuery<HTMLElement> = null;

    private _input: JQuery<HTMLLIElement> = null;
    private _suggestions: JQuery<HTMLLIElement> = null;

    private readonly _classMap = {
        input: ".js-pcg-search-bar__input",
        suggestions: ".js-pcg-smart-search"
    };

    private bindEvents(): void {
        this._input
            .on("keyup", (event) => {
                const searchText = event.target.value.toString().trim();
                if (searchText) {
                    this.debounceSetSuggestions(searchText);
                }
            })
            .on("focusin", (event) => {
                const searchText = event.target.value.toString().trim();
                if (searchText) {
                    this.setSuggestions(searchText);
                }
            })
            .on("focusout", () => setTimeout(() => this.clearSuggestions(), 150)); // workaround to prevent clear before click on link triggered
    }

    private debounceSetSuggestions = debounce((searchText: string) => this.setSuggestions(searchText), 700);

    private clearSuggestions(): void {
        this._suggestions.html("");
    }

    private setSuggestions(searchText: string): void {
        this.clearSuggestions();

        if (searchText.length <= 2) {
            return;
        }

        const url = `${this._apiUrl}?&homePageId=${this._homePageId}&searchText=${searchText}`;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _ = $.getJSON(url).then((response: SearchResponseModel) => {
            SmartSuggestService.getSuggestionElements(response.suggestions.filter(x => x.isRecommended), "Recommended Links")
                .forEach((element: string) => this._suggestions.append(element));
            SmartSuggestService.getSuggestionElements(response.suggestions.filter(x => !x.isRecommended), "Content / Articles")
                .forEach((element: string) => this._suggestions.append(element));
            this._suggestions.append(SmartSuggestService.getShowMoreElement(response.showMoreCount, searchText, this._searchPageUrl));
        });
    }

    private parseContext(): void {
        this._input = $(this._classMap.input, this._context);
        this._suggestions = $(this._classMap.suggestions, this._context);
    }

    public init(context: JQuery, homePageId: string, apiUrl: string, searchPageUrl: string): void {
        this._context = context || this._context;
        this._homePageId = homePageId || this._homePageId;
        this._apiUrl = apiUrl || this._apiUrl;
        this._searchPageUrl = searchPageUrl || this._searchPageUrl;

        this.parseContext();
        this.bindEvents();
    }

    public static init(context: JQuery, homePageId: string, apiUrl: string, searchPageUrl: string): SmartSuggestComponent {
        const component = new SmartSuggestComponent();
        component.init(context, homePageId, apiUrl, searchPageUrl);
        return component;
    }
}

